import { render, staticRenderFns } from "./ButtonPicture.vue?vue&type=template&id=28a9b2fa&scoped=true&"
import script from "./ButtonPicture.vue?vue&type=script&lang=js&"
export * from "./ButtonPicture.vue?vue&type=script&lang=js&"
import style0 from "./ButtonPicture.vue?vue&type=style&index=0&id=28a9b2fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a9b2fa",
  null
  
)

export default component.exports